import React, { Component } from 'react'
import LandingPageFrame from './landing-elements/LandingPageFrame'
import LandingPageBtnRow from './landing-elements/LandingPageBtnRow'
import StoryContent from './landing-elements/StoryContent'
import '../appStyle.css'

/**
 * Wrapper for landing page components to provide to react-router for '/'
 */
export default class Home extends Component {
  /**
   * Render the "Home" page
   */
  render () {
    return (
      <LandingPageFrame>
        <LandingPageBtnRow />
        <StoryContent />
      </LandingPageFrame>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js